import spinner from 'apps/QuoterApp/assets/images/Spinner.svg';

import 'shared/components/SpinnerOverlay/styles.scss';

function SpinnerOverlay({loading}) {
    return !!loading && <div className={"SpinnerOverlay"}>
        <img src={spinner} alt={'Loading...'}/>
    </div>
}

export default SpinnerOverlay;
